<template>
  <div v-if="imgData" class="imgauth">
    <div class="images">
      <!-- <img :src="authData.src" class="img"> -->
      <div v-if="[-1].includes(imgData.status)" class="img imgnone">
        考生未上传
      </div>
      <template v-else>
        <div
          v-if="imgSrc"
          :class="[imgData.prevFileUrl ? 'previewimg' : 'img-view']"
        >
          <el-image
            class="showimg"
            fit="contain"
            :src="imgSrc"
            :preview-src-list="[imgSrc]"
          >
            <div
              @click="onError"
              slot="error"
              style="
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                background: #f5f7fa;
                color: #909399;
                cursor: pointer;
              "
            >
              点击重新加载
            </div>
            <div
              slot="placeholder"
              style="
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                background: #f5f7fa;
                color: #909399;
              "
            >
              <i class="el-icon-loading"></i>
            </div>
          </el-image>
        </div>
        <div
          v-if="imgSrcOld"
          :class="[imgData.prevFileUrl ? 'img-view' : 'previewimg']"
        >
          <el-image
            v-if="imgSrcOld"
            class="showimg"
            fit="contain"
            :src="imgSrcOld"
            :preview-src-list="[imgSrcOldPreview]"
          >
            <div
              @click="onErrorOld"
              slot="error"
              style="
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                background: #f5f7fa;
                color: #909399;
                cursor: pointer;
              "
            >
              点击重新加载
            </div>
            <div
              slot="placeholder"
              style="
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                background: #f5f7fa;
                color: #909399;
              "
            >
              <i class="el-icon-loading"></i>
            </div>
          </el-image>
        </div>
      </template>
      <template v-if="[2].includes(reviewStatus)">
        <template v-if="[1, 2].includes(imgData.status)">
          <div class="ii-mask">
            <template v-if="imgData.status == 1">
              <i
                class="ii-icon el-icon-warning-outline"
                style="transform: rotate(180deg)"
              ></i>
              已打回，待重新提交
            </template>
            <template v-if="imgData.status == 2">
              <i class="ii-icon el-icon-check"></i>
              已通过
            </template>
          </div>
        </template>
        <template v-if="[1].includes(imgData.status)">
          <div @click="onChangeSelect" title="通过" class="ii-check">
            <div
              class="iic-normal iic-item"
              :class="{ 'iic-select': imgData.checked }"
            >
              <i class="el-icon-check"></i>
            </div>
          </div>
          <!-- <div @click="onChangeSelect" title="不通过" class="ii-checkno">
            <div class="iic-normal iic-item" :class="{'iic-selectno': !imgData.checked}">
              <i class="el-icon-close"></i>
            </div>
          </div> -->
        </template>
      </template>
      <template v-if="[1].includes(reviewStatus)">
        <template v-if="[2].includes(imgData.status)">
          <div class="ii-mask">
            <template v-if="imgData.status == 2">
              <i class="ii-icon el-icon-check"></i>
              已通过
            </template>
          </div>
        </template>
        <template v-if="[0, 1].includes(imgData.status)">
          <div
            v-if="imgSrcOld"
            @click="onChangeHistory"
            title="切换历史"
            class="ii-reflesh"
          >
            <div class="iic-normal iic-item iic-reflesh">
              <i class="el-icon-refresh"></i>
            </div>
          </div>
          <div @click="onChangeSelect" title="通过" class="ii-check">
            <div
              class="iic-normal iic-item"
              :class="{ 'iic-select': imgData.checked }"
            >
              <i class="el-icon-check"></i>
            </div>
          </div>
          <div @click="onChangeSelect" title="不通过" class="ii-checkno">
            <div
              class="iic-normal iic-item"
              :class="{ 'iic-selectno': !imgData.checked }"
            >
              <i class="el-icon-close"></i>
            </div>
          </div>
        </template>
      </template>
      <template v-if="[3].includes(reviewStatus)">
        <div class="ii-mask">
          <template v-if="imgData.status == 2">
            <i class="ii-icon el-icon-check"></i>
            已通过
          </template>
          <template v-if="imgData.status == 1">
            <i
              class="ii-icon el-icon-warning-outline"
              style="transform: rotate(180deg)"
            ></i>
            已打回，待重新提交
          </template>
          <template v-if="imgData.status == 0">
            <i
              class="ii-icon el-icon-warning-outline"
              style="transform: rotate(180deg)"
            ></i>
            未审核
          </template>
        </div>
      </template>
    </div>
    <div class="text">{{ imgData.name || imgData.index }}</div>
  </div>
</template>
<script>
import ApiOss from "@/apis/api-oss.js";
export default {
  props: ["authData"],
  data() {
    return {
      imgData: null,
      imgSrc: "",
      imgSrcOld: "",
      imgSrcOldPreview: "",
      isFirst: true,
    };
  },
  computed: {
    // status: 0, // 图片状态 0-待审核 1-不合格 2-合格
    //  reviewStatus: 审核状态 1待审核 2-复审(重新提交) 3-审核完成
    reviewStatus() {
      const currentExam = this.$store.state.authimgStore.currentExam;
      return currentExam ? currentExam.reviewStatus : "";
    },
  },
  watch: {
    authData: {
      async handler() {
        const imgData = JSON.parse(JSON.stringify(this.authData));
        const copyimgData = JSON.parse(JSON.stringify(this.imgData || {}));
        this.imgData = { ...this.imgData, ...imgData };
        if (copyimgData && imgData.fileUrl == copyimgData.fileUrl) {
          return;
        }
        if (this.isFirst) {
          const index = this.imgData.index > 0 ? this.imgData.index : 1;
          await this.onSleep(index);
          this.isFirst = false;
        }
        try {
          if (imgData.fileUrl) {
            const arrImg = imgData.history || [];
            this.imgSrc = await ApiOss.signatureUrlBucket(
              imgData.fileUrl,
              { roleName1: "media", ossBucket: imgData.ossBucket },
              { process: "image/resize,p_30" }
            );
            if (arrImg[1] && arrImg[1].fileUrl && imgData.status !== 2) {
              this.imgSrcOld = await ApiOss.signatureUrlBucket(
                arrImg[1].fileUrl,
                { roleName1: "media", ossBucket: arrImg[1].ossBucket },
                { process: "image/resize,w_300" }
              );
              this.imgSrcOldPreview = await ApiOss.signatureUrlBucket(
                arrImg[1].fileUrl,
                { roleName1: "media", ossBucket: arrImg[1].ossBucket },
                { process: "image/resize,p_30" }
              );
            } else {
              this.imgSrcOld = "";
              this.imgSrcOldPreview = "";
            }
          } else {
            this.imgSrc = imgData.fileUrl;
            this.imgSrcOld = "";
            this.imgSrcOldPreview = "";
          }
        } catch (error) {
          this.imgSrc = imgData.fileUrl;
          this.imgSrcOld = "";
          this.imgSrcOldPreview = "";
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    onSleep(index = 1) {
      return new Promise((resolve, reject) => {
        setTimeout(resolve, (index - 1) * 1000);
      });
    },
    onChangeHistory() {
      // 切换历史
      const arrImg = this.imgData.history || [];
      if (arrImg[1] && arrImg[1].fileUrl) {
        this.imgData.prevFileUrl = this.imgData.prevFileUrl
          ? ""
          : arrImg[1].fileUrl;
      }
      this.$store.dispatch("onSetChecked", this.imgData);
    },
    onChangeSelect() {
      this.imgData.checked = !this.imgData.checked;
      this.$store.dispatch("onSetChecked", this.imgData);
    },
    async onError() {
      const imgData = this.imgData;
      if (imgData.fileUrl) {
        this.imgSrc = await ApiOss.signatureUrlBucket(imgData.fileUrl, {
          roleName1: "media",
          ossBucket: imgData.ossBucket,
        });
      } else {
        this.imgSrc = imgData.fileUrl;
      }
    },
    async onErrorOld() {
      const imgData = this.imgData;
      if (imgData.fileUrl) {
        const arrImg = imgData.history || [];
        if (arrImg[1] && arrImg[1].fileUrl && imgData.status !== 2) {
          this.imgSrcOld = await ApiOss.signatureUrlBucket(
            arrImg[1].fileUrl,
            { roleName1: "media", ossBucket: arrImg[1].ossBucket },
            { process: "image/resize,w_300" }
          );
          this.imgSrcOldPreview = await ApiOss.signatureUrlBucket(
            arrImg[1].fileUrl,
            { roleName1: "media", ossBucket: arrImg[1].ossBucket }
          );
        } else {
          this.imgSrcOld = "";
          this.imgSrcOldPreview = "";
        }
      } else {
        this.imgSrcOld = "";
        this.imgSrcOldPreview = "";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.imgauth {
  width: 100%;
  height: 100%;
  .images {
    position: relative;
    width: 100%;
    height: calc(100% - 30px);
    border: 1px solid rgba(0, 0, 0, 0.25);
    border-radius: 4px;
    .img-view {
      width: 100%;
      height: 100%;
      overflow: hidden;
      .showimg {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    .previewimg {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 40%;
      padding-top: 25%;
      box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.16);
      background: #fff;
      border-top: 1px solid rgba(0, 0, 0, 0.25);
      border-right: 1px solid rgba(0, 0, 0, 0.25);
      // height: auto;
      object-fit: contain;
      z-index: 1;
      .showimg {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
        width: 100%;
        height: 100%;
      }
    }
    .ii-mask {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      background: rgba($color: #000, $alpha: 0.5);
      font-size: 16px;
      font-family: PingFangSC-Regular;
      line-height: 16px;
      color: #fff;
      z-index: 2;
      .ii-icon {
        // font-weight: bold;
        font-size: 38px;
        margin-bottom: 8px;
      }
    }
    // 选择器start
    .ii-check {
      cursor: pointer;
      position: absolute;
      right: 8px;
      bottom: 8px;
      z-index: 2;
    }
    .ii-checkno {
      cursor: pointer;
      position: absolute;
      right: 58px;
      bottom: 8px;
      z-index: 2;
    }
    .ii-reflesh {
      cursor: pointer;
      position: absolute;
      right: 108px;
      bottom: 8px;
      z-index: 2;
    }
    .iic-item {
      width: 36px;
      height: 36px;
      border: 1px solid #fff;
      box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.16);
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
    }
    .iic-normal {
      background: rgba(0, 0, 0, 0.4);
      font-size: 24px;
    }
    .iic-selectno {
      background: #ff6262;
    }
    .iic-select {
      background: #2cd4ad;
    }
    // 选择器end
    .imgnone {
      background: #ededed;
      display: flex;
      justify-content: center;
      align-items: center;
      color: rgba(0, 0, 0, 0.45);
      font-size: 18px;
    }
  }
  .text {
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: center;
  }
}
.imgauth::v-deep .el-image-viewer__close {
  color: #fff;
  top: 10px;
}
</style>
